import React, { useState } from 'react';
import Home from './Home';
import './Tabs.css';

const Tabs = ({ activeTab, setActiveTab }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false); // Mobile menu toggle

  const handleServiceSelect = (service) => {
    setSelectedService(service);
    setActiveTab("ourservices");
    setIsDropdownOpen(false);
    setMenuOpen(false);
  };

  const handleSeeMoreClick = (serviceName) => {
    setSelectedService(serviceName);
    setActiveTab('ourservices');
  };

  return (
    <div>
      <nav className="tabs-nav">
        <div className="top-contact-bar">
          <span><i className="fa fa-envelope"></i> suyochi0623@gmail.com</span>
          <span><i className="fa fa-phone"></i> +91-9036712818</span>
        </div>
        
        <div className="header-bar">
          <div className="logo-container">
            <img src="/images/suyochi_logo.png" alt="Company Logo" className="company-logo" />
          </div>

          <button
            className="hamburger"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>

        <div className={`nav-buttons ${menuOpen ? "show" : ""}`}>
          <button
            className={activeTab === "home" ? "active" : ""}
            onClick={() => {
              setActiveTab("home");
              setMenuOpen(false);
            }}
          >
            Home
          </button>
          <button
            className={activeTab === "aboutus" ? "active" : ""}
            onClick={() => {
              setActiveTab("aboutus");
              setMenuOpen(false);
            }}
          >
            About Us
          </button>

          <button
            className={activeTab === "contactus" ? "active" : ""}
            onClick={() => {
              setActiveTab("contactus");
              setMenuOpen(false);
            }}
          >
            Contact Us
          </button>
        </div>

        {/* <hr /> */}
    </nav>
    <hr />
        {/* Dynamic Content */}
        {activeTab === 'home' && (
          <Home handleSeeMoreClick={handleSeeMoreClick} />
        )}
    </div>
  );
};

export default Tabs;
